import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_MhtcmChild = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_MhtcmChild' className='file-pdf-document'>
            <div className='file-template'>
            <h2>Appendix I</h2>
<h3>Children's Certification</h3>
<h4>Children's Mental Health Targeted Case Management</h4>

<p className='w-750'>Is hereby certified to meet all the following children's mental health targeted case management criteria:</p>
<ol>
    <li>{`Is enrolled in a Department of Children and Families children's mental health target population;`}</li>
    <li>{`Has a mental health disability (i.e, serious emotional disturbances or emotional disturbance) which requires
        advocacy for and coordination of services to maintain or improve level of functioning;`}</li>
    <li>{`Requires services to assist him or her in attaining self sufficiency and satisfaction in the living, learning,
        work and social enviorments of his or her choice;`}</li>
    <li>{`Lacks a natural support system with the ability to access needed medical and social environments of his or her
        choice;`}</li>
    <li>{`Requires ongoing assistance to access or maintain needed care consistently within the service delivery
        system;`}</li>
    <li>{`Has a mental disability (i.e., serious emotional disturbance or emotional disturbance)
        duration that, based upon professional judgment, will last for a minimum of year.`}</li>
    <li>{`Is in out-of-home mental health placement or at documented risk of out of home mental health placement;`}</li>
    <li>{`Is not receiving duplicate case management services from another provider, or`}</li>
    <li>{`Has relocated from a Department of Children and Families district or region where he or she was receiving
        mental health targeted case management services.`}</li>
</ol>
<p className='w-750'><h4>{`Form must be filed in recipient's case record.`}</h4></p>
<p className='w-750'><span>{`AHCA-Med Serv Form 029, July 2006 (incorporated by reference in 59G-4.199, F.A.C.`}</span></p>

                
            </div>
        </form>

    )
}











